type Context = 'customer';

type Section = 'features' | 'members' | 'metadata' | 'intent-topics' | 'icp';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  features: 'customer-features',
  members: 'customer-members',
  metadata: 'customer-metadata',
  'intent-topics': 'customer-intent-topics',
  icp: 'customer-icp',
};
